// extracted by mini-css-extract-plugin
export default {"page":"ContactUsPage_page__Uh+z7"};